import type { CountryLocalizations, TextLocalization } from '../types';

export const norwegianLocalization: TextLocalization = {
  successHeader: 'Betalingen er fullført',
  successDescription: 'Sånn! Betalingen gikk gjennom.',
  cancelledHeader: 'Betalingen er avbrutt',
  cancelledDescription: 'Ingenting er trukket. Prøv igjen når du er klar.',
  inputPlaceholder: 'Telefonnummer',
  inputInputLabel: 'Skriv inn nummeret ditt for å betale med {marketBrandName}',
  inputPrimaryLabel: 'Gå videre for å betale med {marketBrandName}',
  useSavedNumberButton: 'Bruk mitt lagrede {marketBrandName}-nummer',
  continueAsLabel: 'Fortsett som {0}',
  useAnotherNumberLabel: 'Bruk et annet nummer',
  rememberMeLabel: 'Husk nummeret mitt',
  inputPrimary: 'Neste',
  inputCancel: 'Avbryt betalingen',
  inputCancelLabel: 'Avbryt betalingen og gå tilbake til nettbutikken',
  logoTitle: '{marketBrandName} logo',
  localeSelectorLabel: 'Valg av språk, {0} valgt',
  countryCodeSelectorLabel: 'Velg land, {0} valgt',
  statusHeader: 'Åpne {marketBrandName}',
  statusAriaLabel:
    'Du har {0} minutter og {1} sekunder på å åpne {marketBrandName} og fullføre betalingen.',
  statusContent: 'Vi har sendt en betalingsforespørsel til {0}',
  errorHeader: 'Uffda, noe gikk galt',
  errorContent: 'Prøv igjen.',
  errorPrimary: 'Gå tilbake',
  timeoutHeader: 'Å nei, tiden gikk ut',
  scanToOpenInKlarna: 'Skann for å legge til Klarna i {marketBrandName}',
  addKlarna: 'Legg til Klarna i {marketBrandName}',
  openVipps: 'Åpne {marketBrandName}',
  timeoutContent: 'Gå tilbake og prøv igjen.',
  timeoutPrimary: 'Gå tilbake',
  inputCountryCodeLabel: 'Landskode',
  inputError: 'For å fortsette må du ha {marketBrandName} på mobilen din og være fylt 15 år.',
  openInKlarnaMobileText: 'Åpne fra mobilen? Trykk her',
  inputErrorNoEdit:
    'Denne bedriften krever at du bruker samme mobilnummer som du bruker i profilen din.',
  statusNumberFallback: 'nummeret ditt.',
  dropDownOptionsLabel: 'Alternativer',
  qrAltTag: 'QR-kode for betaling',
  qrSeparator: 'eller bruk telefonnummeret ditt',
  upgradeApp: 'Ser du denne teksten? Oppdater appen din.',
  cookieDeclarationText:
    'Vi bruker bare de informasjonskapslene som er nødvendige for at nettsiden vår skal fungere som den skal.',
  cookieDeclarationLink: 'Les mer om vår bruk av {cookieDeclaration}.',
  cookieDeclaration: 'informasjonskapsler',
  scanToPay: 'Skann og betal',
  paymentTo: 'til',
  skipToContent: 'Hopp til innhold',
  inputHeadingAmount: 'Betal {0} til {1}',
  inputHeadingRecurring: 'Betal til {0}',
  inputDescription: 'Skriv inn telefonnummeret ditt og fullfør betalingen i {marketBrandName}.',
  inputDescriptionQr: 'Skann QR-koden og fullfør betalingen i {marketBrandName}.',
};

export const norwegianCountryLocalization: CountryLocalizations = {
  britain: {
    country: '',
    language: 'Engelsk',
  },
  denmark: {
    country: 'Danmark',
    language: 'Dansk',
  },
  finland: {
    country: 'Finland',
    language: 'Finsk',
  },
  norway: {
    country: 'Norge',
    language: 'Norsk',
  },
  sweden: {
    country: 'Sverige',
    language: 'Svensk',
  },
  greenland: {
    country: 'Grønland',
    language: 'Engelsk',
  },
};
